export default __webpack_public_path__ + "static/voice-data-b401d6820287d0e7ce3b98bde854766a.webp";